/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalEvidenceImageSignedUrl
 */
export interface ExternalEvidenceImageSignedUrl {
    /**
     * 
     * @type {string}
     * @memberof ExternalEvidenceImageSignedUrl
     */
    signedUrl: string;
}

/**
 * Check if a given object implements the ExternalEvidenceImageSignedUrl interface.
 */
export function instanceOfExternalEvidenceImageSignedUrl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;

    return isInstance;
}

export function ExternalEvidenceImageSignedUrlFromJSON(json: any): ExternalEvidenceImageSignedUrl {
    return ExternalEvidenceImageSignedUrlFromJSONTyped(json, false);
}

export function ExternalEvidenceImageSignedUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEvidenceImageSignedUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signedUrl': json['signed_url'],
    };
}

export function ExternalEvidenceImageSignedUrlToJSON(value?: ExternalEvidenceImageSignedUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signed_url': value.signedUrl,
    };
}

